export const ProviderDe = () => {
    return (
        <>
            <h1>Anbieter</h1>
            <ul>
                <li>Daimler Truck AG</li>
                <li>Fasanenweg 10</li>
                <li>70771 Leinfelden-Echterdingen</li>
                <li>Deutschland</li>
                <li>Tel.: +49 711 8485-0</li>
                <li>Email: <a href='mailto:contact@daimlertruck.com' className='wb-link wb-link--inline'>contact@daimlertruck.com</a></li>
            </ul>

            <h1>Vertreten durch den Vorstand:</h1>
            <p>Karin Rådström (Vorsitzende), Yvonne Bettkober, Andreas Gorbach, Jürgen Hartwig, John O‘Leary, Achim Puchert, Eva Scherer</p>

            <h1>Vorsitzender des Aufsichtsrats:</h1>
            <p>Joe Kaeser</p>
            <ul>
                <li>Handelsregister beim Amtsgericht Stuttgart, Nr. HRB 762884</li>
                <li>Umsatzsteueridentifikationsnummer: DE 32 12 81 771</li>
            </ul>
        </>
    );
};